<div class="stages-block">
  @if (miniView === true && !only_history) {
    <div class="color-highlight mb-2" [ngClass]="{
      'done' : data['status'] !== 'fail',
      'fail' : data['status'] === 'fail'
      }"
      >
      <div class="color-highlight-round"></div><div [innerHtml]="{
      'fail': 'Отказ',
      'finish': 'Архив'
      }[data['status']] || 'В&nbsp;работе'"></div>
  </div>
}
@if (miniView !== true) {
  <div class="stages-block__dots"
    >
    @for (el of dotArray; track el; let i = $index) {
      <div class="stages-block__dots__element" [ngClass]="{'active': i < data.bp_stages_current}"></div>
    }
  </div>
}
<div class="text-nowrap">
  @if (info) {
    <a href="javascript: void(0)" (click)="rightWindow = true">Подробнее</a>
  }
  @if (miniView !== true && !only_history) {
    {{data.bp_stages_current}} / {{data.bp_stages_count}}<br>{{data.stage_caption}}<br><span
  class="c-red">{{data.status_description_short}}</span>
}
@if (data.comment_for_subagent) {
  <popover-content #popovercomment [title]="'Комментарий для субагента'"
    [placement]="'left'" [closeOnClickOutside]="true"
    [closeOnMouseOutside]="false">
    <div [innerHtml]="data.comment_for_subagent"></div>
  </popover-content>
  <div [popover]="popovercomment" class="d-inline-block ml-1">
    <i class="fa fa-2x fa-fw fa-question-circle c-pointer"></i>
  </div>
}
</div>
</div>

@if (info) {
  <app-right-window
    [data]="rightWindow"
    [cssClass]="cssClass"
    (onClosedRight)="onClosedRight()">
    <div class="row no-gutters gutters-4">
      <div class="col-12">
        <h2 class="mt-2r">История работы</h2>
      </div>
      @if (manager_fio) {
        <div class="col-12 mt-3">
          Ваш менеджер: <b>{{manager_fio}} {{manager_phone}}</b>
        </div>
      }
      <div class="col-12">
        @if (info.length) {
          <div class="row no-gutters gutters-4">
            <div class="col-sm-12 mt-3 mb-2">
              <table class="table history table-rwd">
                <tr>
                  <th>Дата</th>
                  <th>Событие</th>
                </tr>
                @for (operation of info; track operation; let i = $index) {
                  <tr>
                    <td>
                      {{operation['date_time']}}
                    </td>
                    <td>
                      <span class="history__colorblock" [ngClass]="operation['status']"></span>
                      <span class="history__gray">{{operation['status_change_description']}}</span>
                      @if (operation['old_stage_caption'] && operation.show_second_piece) {
                        <span> {{operation['old_stage_caption']}}</span>
                        <span class="history__gray"> на </span>
                      }
                      <span> {{operation['new_stage_id']}}</span>
                      @if (operation['next_contact_date']) {
                        <span class="history__gray"> до </span>
                        {{operation['next_contact_date']}} {{operation['next_contact_time']}}
                      }
                      @if (operation['comment_for_subagent']) {
                        <p> <span class="history__gray">Комментарий </span> <span [innerHTML]="operation['comment_for_subagent']"></span></p>
                      }
                    </td>
                  </tr>
                }
              </table>
            </div>
          </div>
        }
      </div>
    </div>
  </app-right-window>
}
